var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { TabGroupStyles, TabGroupButtonStyles } from './TabGroupStyles';
import { randomString } from '../../utils/randomString';
export var TabGroup = function (_a) {
    var tabs = _a.tabs, _b = _a.activeTabNumber, activeTabNumber = _b === void 0 ? 0 : _b, onTabClick = _a.onTabClick, validateTabClick = _a.validateTabClick, disabled = _a.disabled, _c = _a.breakIntoRow, breakIntoRow = _c === void 0 ? true : _c, _d = _a.tabFocusTrap, tabFocusTrap = _d === void 0 ? 0 : _d;
    var itemsRef = useRef([]);
    var _e = useState(0), activeTab = _e[0], setActiveTab = _e[1];
    var _f = useState([]), tabLabels = _f[0], setTabLabels = _f[1];
    var _g = useState(-1), focused = _g[0], setFocused = _g[1];
    var _h = useState([]), labelWidths = _h[0], setLabelWidths = _h[1];
    var idRef = useRef(randomString());
    useEffect(function () {
        var updatedTab = activeTabNumber;
        if (updatedTab < 0)
            updatedTab = 0;
        if (updatedTab > tabs.length)
            updatedTab = tabs.length;
        setActiveTab(updatedTab);
    }, [activeTabNumber]);
    useEffect(function () {
        if (activeTabNumber !== activeTab) {
            setActiveTab(activeTabNumber);
        }
        setTabLabels(tabs);
    }, [tabs]);
    var handleTabClicked = function (index) {
        var valid = validateTabClick ? validateTabClick() : true;
        if (valid) {
            setActiveTab(index + 1);
            if (onTabClick)
                onTabClick(index + 1);
        }
    };
    useLayoutEffect(function () {
        var lengthArray = tabLabels === null || tabLabels === void 0 ? void 0 : tabLabels.map(function (value, i) {
            var _a;
            return ((_a = itemsRef.current[i]) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        });
        setLabelWidths(lengthArray);
    }, [tabLabels]);
    var handleOnClick = function (index) {
        setFocused(-1);
        if (!disabled) {
            handleTabClicked(index);
        }
    };
    return (_jsx(TabGroupStyles, __assign({ breakIntoRow: breakIntoRow }, { children: tabLabels.map(function (tab, index) {
            return (_jsx(TabGroupButtonStyles, __assign({ ref: function (el) { return (itemsRef.current[index] = el); }, focused: focused, index: index, labelWidths: labelWidths, activeTab: activeTab, breakIntoRow: breakIntoRow }, { children: _jsxs("div", __assign({ id: "".concat(idRef.current, "-").concat(index), className: "tab ".concat(activeTab === index + 1 ? 'active' : ''), onClick: function () { return handleOnClick(index); } }, { children: [_jsx("div", __assign({ className: "tab-label" }, { children: tab.label })), _jsx("button", { "aria-labelledby": "".concat(idRef.current, "-").concat(index), className: "button-hidden", onClick: function () { return handleOnClick(index); }, onMouseDown: function (e) {
                                e.preventDefault();
                                handleOnClick(index);
                            }, disabled: disabled, onFocus: function () {
                                setFocused(index);
                            }, onBlur: function () { return setFocused(-1); }, tabIndex: tabFocusTrap || (activeTab === index + 1 ? -1 : 0) })] })) })));
        }) })));
};
